const DEFAULT_TITLE_MATCH = 'default';
const FOUR_DAY_TITLE_MATCH = '4-day';

const normalize = (title) => (title || '').toLowerCase();

const isDefaultPolicy = (policy) => normalize(policy?.title).includes(DEFAULT_TITLE_MATCH);

const isFourDayPolicy = (policy) => normalize(policy?.title).includes(FOUR_DAY_TITLE_MATCH);

/**
 * Filters the raw policy list from the BE to only the two policies surfaced
 * by the new DSO-level Cancellation Policy feature: "Default" and "4-Day".
 *
 * @param {Array<{id: string, title: string}>} policies
 * @returns {Array<{id: string, title: string}>}
 */
export const filterCancellationPolicies = (policies) => {
  if (!Array.isArray(policies)) return [];
  return policies.filter((p) => isDefaultPolicy(p) || isFourDayPolicy(p));
};

/**
 * Returns the ID of the "Default Cancellation Policy" from the BE list,
 * used as the fallback when a record has no policy explicitly assigned.
 *
 * @param {Array<{id: string, title: string}>} policies
 * @returns {string | undefined}
 */
export const getDefaultCancellationPolicyId = (policies) => {
  if (!Array.isArray(policies)) return undefined;
  return policies.find(isDefaultPolicy)?.id;
};
